var file_upload_viewer_default = {
  "fontElementMap": "_9wUIQ",
  "file_upload_container": "SENGN",
  "file_upload_link": "fxFmd",
  "file_upload_error_container": "pMXMm",
  "file_upload_file_info": "_5g-co",
  "file_upload_type_icon": "GVV0T",
  "file_upload_status_icon_container": "_7mfsG",
  "file_upload_status_icon": "UWiXx",
  "file_upload_description": "orOmf",
  "file_upload_name_container": "QTRvc",
  "file_upload_name": "VwRQy",
  "file_upload_extension": "rEdt4",
  "file_loader_icon": "hkiFm",
  "file_upload_icon_frame": "_-9jAD",
  "file_upload_icon_background": "cLeKF"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
